import script from "./TeacherAttendanceFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./TeacherAttendanceFilters.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__